import Typing from "../../../../shared/typing";
import React, { useEffect } from "react";
import './chatbotTitle.css';

const ChatbotTitle = ({ titles, onCompleteLast }) => {
    const [showSecondLine, setShowSecondLine] = React.useState(false);
    const [activeTitle, setActiveTitle] = React.useState(0);
    const lastCompleted = React.useRef(-1);

    useEffect(() => {
        setActiveTitle(lastCompleted.current);
        setTimeout(() => {
            setActiveTitle(lastCompleted.current + 1);
        }, 60);
    }, [titles]);

    if (titles?.length) {
        return (
            <div className="chatbot-title">
                <div>
                    {titles.length > 0 && titles.map((title, i) => (
                        <div key={i} className="chatbot-title__second-line" style={{
                            height: i <= activeTitle ? '100%' : 0,
                        }}>
                            {i <= activeTitle && <Typing
                                text={title}
                                delay={500}
                                speed={30}
                                onComplete={() => {
                                    if(activeTitle == i) {
                                        setActiveTitle(i + 1);
                                    }
                                    if(titles.length == i + 1 && lastCompleted.current < i) {
                                        lastCompleted.current = i;
                                        onCompleteLast?.();
                                    } 
                                }}
                            />}
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    return (
        <div className="chatbot-title">
            <div>
                <Typing
                    text="Guau Guau! Guau?"
                    speed={30}
                    onComplete={() => setShowSecondLine(true)}
                />
            </div>
            <div className="chatbot-title__second-line" style={{
                height: showSecondLine ? '36px' : 0,
            }}>
                {showSecondLine && <Typing
                    text="¿Qué quieres preguntarle a Firulais?"
                    delay={400}
                    speed={30}
                />}
            </div>
        </div>
    );
};

export default ChatbotTitle;
